import React from "react";
import Navbar from "../Navbar/Navbar";
import { useState, useEffect } from "react";
import { API } from "../../Redux/actions/API";
// import { ToastContainer, toast } from 'react-toastify';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import { useNavigate } from "react-router-dom";
import "./Replay.css";

function Reply() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [id, setId] = useState(searchParams.get("Id"));
  const [subject, setSub] = useState("");
  const [query, setQuery] = useState("");
  const [reply, setReply] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [referralData, setReferralData] = useState([]);
  const Massage_API = async () => {
    try {
      let res = await API.post(
        `/UpdateHelpdeskByAdmin`,
        {
          loginid: userId,
          id: id,
          reply: reply,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );

      //console.log("res", res);
      if (res.data.data === "success") {
        toast.success("Reply Successfully !!");
        setTimeout(() => {
          navigate("/HelpDesk");
        }, 1000);
      } else {
        toast.error(res.data.data);
      }
    } catch (e) {
      console.log("Somthing Error in Massage API", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const referral_API = async () => {
    try {
      let responceRight = await API?.post(
        `/GetHelpdeskuserById`,
        {
          id: id,
          loginid: userId,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );

      responceRight = responceRight.data?.data[0];
      setReferralData(responceRight);
    } catch (e) {
      console.log("Error While calling Myteam API", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    referral_API();
  }, []);
  const chatEndRef = useState(null);
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [referralData]);

  return (
    <div className="ReplyPage">
      <Navbar />
      <div className="content-page">
        <div
          id="content"
          className="content col-lg-12 col-sm-12 ng-scope"
          ng-controller="activateidByZeroPinCtl"
        >
          <div className="panel panel-primary">
            <div className="panel-heading">
              <h4 className="panel-title">Reply Form</h4>
            </div>
            <div
              className="panel-body table-rep-plugin"
              style={{ padding: "8px" }}
            >
              <div className="row">
                <div className="box col-md-12">
                  <div className="alert alert-block alert-info">
                    <div className="row">
                      <div className="col-md-6 mr-30">
                        <div className="modal-dialog" role="document">
                          <div className="modal-content">
                            <div className="modal-body">
                              <div className="popup_net">
                                <h1 className="fw-bold">Reply Message</h1>
                                <span
                                  className="metamaskConnection"
                                  style={{ color: "#fff" }}
                                ></span>
                                {/* <!---onclick number increase start--> */}
                                <div className="form-group">
                                  <label>User Id</label>
                                  <input
                                    type="text"
                                    id="txtuid"
                                    className="form-control"
                                    placeholder="User Id"
                                    value={id}
                                    readOnly
                                  />
                                </div>
                                <div className="chat-box">
                                  {isLoading ? (
                                    <p>Loading...</p>
                                  ) : referralData.length === 0 ? (
                                    <p className=" text-center text-white ">
                                      No data found
                                    </p>
                                  ) : (
                                    referralData.map((item, index) => (
                                      <div key={index}>
                                        {item.subject === "Admin reply" ? (
                                          <div className={`chat-msg user`}>
                                            <div className="msg-bubble">
                                              {item.query}
                                              <span className="tick seen">
                                                {item.status === "open"
                                                  ? "✔"
                                                  : "✔✔"}
                                              </span>
                                            </div>
                                            <div className="date text-end">
                                              {item.edate}
                                            </div>
                                          </div>
                                        ) : (
                                          <div class="chat-msg bot">
                                            <div class="msg-bubble">
                                              {" "}
                                              {item.query}
                                            </div>
                                            <div className="botdate">
                                              {item.edate}
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    ))
                                  )}
                                  <div ref={chatEndRef}></div>
                                </div>
                                <div className="chat-input">
                                  <input
                                    id="txtuid"
                                    type="text"
                                    placeholder="Type message..."
                                    onChange={(e) => setReply(e.target.value)}
                                  />

                                  <button onClick={() => Massage_API()}>
                                    <i
                                      className="fa fa-paper-plane"
                                      aria-hidden="true"
                                    ></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    // </div>
  );
}

export default Reply;
